export const USER_GENDER = ['Male', 'Female', 'Other'] as const;

export type UserGender = typeof USER_GENDER[number];

export enum Gender {
  'Male',
  'Female',
  'Other',
}
